export const INCOME_ACCIDENT = {
  isHidden: true,
  nickname: 'PRODUCTS.INCOME_ACCIDENT.nickname',
  icon:'income-accident'
};
